<form
  [appDynamicPhoneValidation]="dynamicPhoneDirectiveConfig"
  [formGroup]="form"
  appHandleClerkCreateMinorSubmit>
  <div>
    <p class="text-sm italic neutral-900 font-stretch-condensed mb-5">
      Use this option if you are applying in your personal capacity. If you are
      applying on behalf of a business or legal entity, select "Firm" instead.
    </p>
    <mat-slide-toggle class="ccs-toggle mb-4" formControlName="isFirm"
      >Applying as a Firm</mat-slide-toggle
    >
  </div>
  <div class="grid grid-cols-2 gap-4">
    @if (!isFirm()) {
      <div class="flex flex-col gap-1 col-span-2">
        <app-autocomplete
          [isFirm]="form.controls.isFirm.value"
          [options]="formattedUsersByName()"
          [loading]="isLoading()"
          appHandleUserSearch
          appHandleAutocompleteOptionClick
          [searchType]="'firstName'"
          formControlName="firstName"
          label="First Name" />

        @if (
          form.controls.firstName.invalid && form.controls.firstName.touched
        ) {
          @if (form.controls.firstName.errors?.['required']) {
            <form-message message="First Name is required." />
          }
          @if (form.controls.firstName.errors?.['minlength']) {
            <form-message
              message="First Name must be at least 2 characters long." />
          }
          @if (form.controls.firstName.errors?.['pattern']) {
            <form-message message="First Name should have a valid format" />
          }
        }
      </div>

      <app-ccs-input
        size="md"
        formControlName="middleName"
        label="Middle Name (Optional)"
        placeholder="Enter your middle name" />

      <app-ccs-input
        size="md"
        formControlName="lastName"
        label="Last Name"
        placeholder="Enter your last name" />
    } @else {
      <div class="flex flex-col gap-1 col-span-2">
        <app-autocomplete
          [isFirm]="form.controls.isFirm.value"
          [options]="formattedUsersByName()"
          [loading]="isLoading()"
          appHandleUserSearch
          appHandleAutocompleteOptionClick
          [searchType]="'firstName'"
          formControlName="firstName"
          label="Firm Name" />

        @if (
          form.controls.firstName.invalid && form.controls.firstName.touched
        ) {
          @if (form.controls.firstName.errors?.['required']) {
            <form-message message="Firm Name is required." />
          }
          @if (form.controls.firstName.errors?.['minlength']) {
            <form-message
              message="Firm Name must be at least 2 characters long." />
          }
          @if (form.controls.firstName.errors?.['pattern']) {
            <form-message message="Firm Name should have a valid format" />
          }
        }
      </div>
    }

    <app-ccs-select
      size="md"
      label="Phone Prefix"
      displayKey="label"
      valueKey="value"
      formControlName="prefixPhone"
      placeholder="Select an option"
      [options]="phonePrefixOptions" />
    @if (isPhonePrefixUS) {
      <app-ccs-input
        size="md"
        appPhoneNumberMask
        formControlName="phoneNumber"
        label="Phone Number (Optional)"
        placeholder="Enter your phone number" />
    } @else {
      <app-ccs-input
        size="md"
        formControlName="phoneNumber"
        label="Phone Number (Optional)"
        placeholder="Enter your phone number" />
    }

    <div class="col-span-2">
      <app-autocomplete
        [isFirm]="form.controls.isFirm.value"
        appHandleAutocompleteOptionClick
        [searchType]="'email'"
        [options]="formattedUsersByEmail()"
        [loading]="isLoading()"
        appHandleUserSearch
        formControlName="email"
        label="Email address (Optional)" />
      @if (form.controls['email'].invalid && form.controls['email'].touched) {
        @if (form.controls['email'].errors?.['required']) {
          <form-message message="Email is required." />
        }
        @if (form.controls['email'].errors?.['pattern']) {
          <form-message message="Please enter a valid email address." />
        }
      }
    </div>

    <app-ccs-input
      size="md"
      formControlName="username"
      label="Username"
      placeholder="Enter your username" />
    <app-ccs-select
      size="md"
      [options]="relationshipOptions"
      formControlName="relationshipToMinor"
      label="Relationship to Minor"
      placeholder="Select a relationship"
      valueKey="value"
      displayKey="label" />
    <app-ccs-input
      size="md"
      class="col-span-2"
      formControlName="minorFirstName"
      label="Minor's First Name"
      placeholder="Enter Minor First Name" />
    <app-ccs-input
      size="md"
      formControlName="minorLastName"
      label="Minor's Last Name"
      placeholder="Enter Minor Last Name" />
    <app-ccs-date
      size="md"
      placeholder="mm/dd/yyyy"
      [errorMessages]="minorAgeErrorMessage"
      [max]="today"
      formControlName="minorDateOfBirth"
      label="Birthdate" />

    @if (isOtherRelationship()) {
      <app-input-file
        class="col-span-2"
        [acceptedFileTypes]="acceptedFileTypes"
        formControlName="courtOrder"
        label="Court Order" />
    }
    @if (is14OrOlder() && !isOtherRelationship()) {
      <app-input-file
        class="col-span-2"
        [acceptedFileTypes]="acceptedFileTypes"
        formControlName="affidavit"
        label="Affidavit on behalf of the Minor" />
    }
    <div class="flex col-span-2 gap-2">
      <ui-button appCloseApplicationModal variant="tertiary" class="w-full">
        Cancel
      </ui-button>
      <ui-button
        appHandleClerkCreateMinorSubmit
        variant="primary"
        class="w-full"
        [disabled]="form.invalid"
        type="submit">
        Create
      </ui-button>
    </div>
  </div>
</form>
